import { Currency, ID } from '@debbie/common/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import Billings from '@debbie/iris/dist/components/economy/Billings.js'
import Modal from '@debbie/iris/dist/components/Modal.js'
import THEME from '@debbie/iris/dist/theme.js'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

type Props = {
  caseId: ID
  tenantId: ID
  currency: Currency
  creditorId: ID
}

const CreditorBillingModal = (props: Props) => {
  const lang = useSelector((s: RootState) => s.lang)

  const [modalOpen, setModalOpen] = useState(false)

  return (
    <p style={{ fontSize: '0.9em', margin: 0 }}>
      <b
        style={{
          color: THEME.COLOR_ACCENT,
          cursor: 'pointer',
        }}
        onClick={() => {
          setModalOpen(!modalOpen)
        }}
      >
        {lang.clientBilling.seeDetailsCreditor}
      </b>
      {modalOpen && (
        <Modal
          onToggle={() => setModalOpen(!modalOpen)}
          header={lang.billing.bills}
        >
          <Billings
            caseId={props.caseId}
            highlightCaseId={props.caseId}
            creditorId={props.creditorId}
          />
        </Modal>
      )}
    </p>
  )
}

export default CreditorBillingModal
